module.exports = __webpack_public_path__ + "static/media/forClassroom.1379f7f3.png";